import { useEffect, useState } from "react";
import Backdrop from "./Backdrop";
import styles from "./Dialog.module.css";

export const UploadingDialog = (props) => {
  const { show, onContinueBackground, estimatedMinutes = 4 } = props;
  const [remainingSeconds, setRemainingSeconds] = useState(
    estimatedMinutes * 60
  );
  const [progress, setProgress] = useState(0);

  const totalSeconds = estimatedMinutes * 60;

  useEffect(() => {
    if (show) {
      // Reset when dialog opens
      setRemainingSeconds(estimatedMinutes * 60);
      setProgress(0);
    }
  }, [show, estimatedMinutes]);

  useEffect(() => {
    if (!show || remainingSeconds <= 0) return;

    const timer = setInterval(() => {
      setRemainingSeconds((prev) => {
        const newValue = prev - 1;
        // Stop at 0, don't go negative
        return newValue >= 0 ? newValue : 0;
      });

      // Update progress based on time elapsed
      setProgress((prev) => {
        const elapsed = totalSeconds - remainingSeconds + 1;
        const newProgress = (elapsed / totalSeconds) * 100;
        return newProgress >= 100 ? 100 : newProgress;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [show, remainingSeconds, totalSeconds]);

  const displayMinutes = Math.ceil(remainingSeconds / 60);

  return show ? (
    <div>
      <Backdrop show={show} />
      <div className={styles.uploadingDialog}>
        <div className={styles.uploadingContent}>
          <h2 className={styles.uploadingTitle}>Processing your Upload</h2>

          <div className={styles.progressBarContainer}>
            <div
              className={styles.progressBarFill}
              style={{ width: `${progress}%` }}
            />
          </div>

          {remainingSeconds > 0 && (
            <div className={styles.uploadingText}>
              This may take {displayMinutes} more{" "}
              {displayMinutes === 1 ? "minute" : "minutes"}
            </div>
          )}

          {remainingSeconds === 0 && (
            <div className={styles.uploadingText}>Almost done...</div>
          )}

          <button
            className={styles.continueButton}
            onClick={onContinueBackground}
          >
            Continue in Background
          </button>
        </div>
      </div>
    </div>
  ) : null;
};
